module.exports = __webpack_public_path__ + "media/images/product_owners/mctssa-0d4a396776f41e33ed0629fcd38fe7db.png";